import { Image } from "./image";
import React from "react";
import img2 from "../assets/gallary/img2.jpg"
import img3 from "../assets/gallary/img3.png"
import img4 from "../assets/gallary/img4.png"
import img5 from "../assets/gallary/img5.png"
import img6 from "../assets/gallary/img6.png"

export const Gallery = (props) => {

  let data = [
    {
      "title": "Yelagiri Birds Park",
      "largeImage": img3,
      "smallImage": img3
    },
    {
      "title": "Queens Travels",
      "largeImage": img5,
      "smallImage": img5
    },
    {
      "title": "New Greens Inn",
      "largeImage": img4,
      "smallImage": img4,
    },
    {
      "title": "Education",
      "largeImage": img6,
      "smallImage": img6
    },
    {
      "title": "Blog Management",
      "largeImage": img2,
      "smallImage": img2
    },
    {
      "title": "Our Team",
      "largeImage": "img/portfolio/07-large.jpg",
      "smallImage": "img/portfolio/07-small.jpg"
    },
    {
      "title": "Our Team",
      "largeImage": "img/portfolio/09-large.jpg",
      "smallImage": "img/portfolio/09-small.jpg"
    }
  ]

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Works</h2>
          <p>
            Explore our work, team moments, and innovative projects through a collection of images showcasing our journey and achievements.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-sm-6 col-md-4 col-lg-4"
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
